import SavingsIcon from "@mui/icons-material/Savings";
import type { ReactNode } from "react";
import { ValueTile } from "Components/Shared/ValueTile/ValueTile";

type Props = {
  isLoading: boolean;
  value: string;
  title: string;
  explanationHint: ReactNode;
};

export const RewardsValue = ({
  isLoading,
  value,
  title,
  explanationHint,
}: Props) => (
  <ValueTile
    isLoading={isLoading}
    icon={<SavingsIcon />}
    title={title}
    value={value}
    variant="basic"
    explanationHint={explanationHint}
  />
);
